import { render, staticRenderFns } from "./SubsidiariesList.vue?vue&type=template&id=03b9e533&"
import script from "./SubsidiariesList.vue?vue&type=script&lang=ts&"
export * from "./SubsidiariesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports